import '../styles/ui/nav.scss'
import { NavLink, useLocation } from 'react-router-dom';
import useWindowDimensions from '../utility/DimensionTracker';
import { useState, useEffect } from 'react';

const NavBar = ({isPlaying, setMusic}) => {

    const [isOpen, setOpen] = useState(false)
    const { height, width } = useWindowDimensions();

    const location = useLocation();
    const [atTop, setAtTop] = useState(true)

    useEffect(()=>{
        location.pathname === '/' ? setAtTop(false) : setAtTop(true)
    },[location])

    return (
        atTop && <div className={`nav-container ${width <= 900 && "mobile"}`}>
            {
                width <= 900 &&
                <div className='button-wrapper'>
                    <button className={`${isOpen ? 'menu-button-open' : 'menu-button-close'}`}
                        onClick={()=>{
                            setOpen(!isOpen)
                        }}
                    >
                        <div className="hamburger-line-1"></div>
                        <div className="hamburger-line-2"></div>
                        <div className="hamburger-line-3"></div>
                    </button>
                </div>
            }
            <div className={width <= 900 ? 'nav-list-mobile' : 'nav-list'}>
                <div className={`${width <= 900 ? isOpen ? 'open-nav' : 'closed-nav' : 'regular-nav'}`}>
                    <NavLink to="/" className={({isActive})=>isActive ? 'active-link' : 'inactive' }>Top</NavLink>
                    <NavLink to="/story" className={({isActive})=>isActive ? 'active-link' : 'inactive' }>Story</NavLink>
                    <NavLink to="/characters" className={({isActive})=>isActive ? 'active-link' : 'inactive' }>Characters</NavLink>
                    <NavLink to="/system" className={({isActive})=>isActive ? 'active-link' : 'inactive' }>System</NavLink>
                    <NavLink to="/media" className={({isActive})=>isActive ? 'active-link' : 'inactive' }>Media</NavLink>
                    <NavLink to="/products" className={({isActive})=>isActive ? 'active-link' : 'inactive' }>Products</NavLink>
                    <button className={`music-btn ${isPlaying ? 'playing' : 'paused'}`} onClick={()=>{
                        setMusic(!isPlaying)
                    }}></button>
                </div>

            </div>
        </div>
    )
}

export default NavBar;